import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/wh-support-docs/wh-support-docs/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import { Link } from "gatsby";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2>{`Welcome`}</h2>
    <p>{`For a quick overview of Cúram Education, see the following short introductory `}<a href="https://youtu.be/3H9YaVM0au0" target="_blank">{`video`}</a>{`.`}</p>
    <p>{`For all things new in Cúram Education, please see our latest `}<a parentName="p" {...{
        "href": "/wh-support-docs/pdf/education/CuramEducationNewsletterNov2025.pdf"
      }}>{`Newsletter`}</a></p>
    <h2>{`Why take training?`}</h2>
    <p>{`If you’ve seen anything of the Cúram software, chances are you appreciate that it is a big product, with not just vast functionality to support complex business use cases, but also technically sophisticated and very configurable.`}</p>
    <h2>{`Who is Cúram Education for?`}</h2>
    <p>{`Our training typically falls into one of two categories. It’s broadly either for Business users or for Technical users - not only that, but it ranges from the 10,000ft viewpoint, all the way down to the lowest-level detail. We understand not everyone has the same needs.`}</p>
    <h2>{`In what formats are courses offered?`}</h2>
    <h3>{`Presentation Format`}</h3>
    <p>{`Almost all training courses are offered in presentation format - meaning that a course is typically created as a presentation that can be either consumed independently by the student (this is usually referred to as Self-Paced Learning), or an instructor may deliver it (remotely, or in person).`}</p>
    <h3>{`Personal Lab Environments`}</h3>
    <p>{`Since we perceive there to be significant value in ‘learning by doing’, there are practical exercises that accompany every topic of every course, performed by the student in their own, personal copy of a lab environment - this is a specially-configured virtual machine, which runs the Cúram software, set up in a certain way to support the lab exercises and learning experience of the student.`}</p>
    <h2>{`What courses and learning paths are available?`}</h2>
    <p>{`We understand that different students have different needs, and so our training is organized into specific learning paths, mostly aligned with the different core role types (i.e. Business User, or Technical User).`}</p>
    <p>{`To explore these learning paths, see our `}<Link to="/spm/education/learning_paths" mdxType="Link">{`Learning Paths`}</Link>{` page.`}</p>
    <p>{`For a full list of the courses, see our `}<Link to="/spm/education/training_courses" mdxType="Link">{`Available Courses`}</Link>{` page.`}</p>
    <p>{`Information on Pricing is available here: `}<a parentName="p" {...{
        "href": "/wh-support-docs/pdf/education/CuramEducationPricingMay2026.pdf"
      }}>{`Education Pricing`}</a></p>
    <h2>{`Cúram Certification Program`}</h2>
    <p>{`The V8.X Business Analyst Certification Test and V8.X Developer Certification Tests are available through our testing provider, Prometric.`}</p>
    <p>{`For more information, see the `}<Link to="/spm/education/certification" mdxType="Link">{`Cúram Certification Program`}</Link>{`.`}</p>
    <h2>{`How can I access Cúram training?`}</h2>
    <p>{`To review what training we offer, check out the `}<Link to="/spm/education/training_courses" mdxType="Link">{`Available Courses`}</Link>{` page.`}</p>
    <p>{`If you are ready to take our training, please submit your request using `}<Link to="https://bit.ly/curamcourserequest" target="new" mdxType="Link">{`this form`}</Link>{`.`}</p>
    <h2>{`Contact us`}</h2>
    <p>{`To get in touch generally, please email `}<a parentName="p" {...{
        "href": "mailto:curameducation@merative.com"
      }}>{`curameducation@merative.com`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      